import { Button } from '@mui/material';
import useAppStore from '../../store/app';
import { Link } from 'react-router-dom';

const buttonStyle = {
  color: 'black',
  textTransform: 'none',
  fontSize: '15px',
  ml: '20px',
  borderRadius: '0',
};

/**
 * The top navigation buttons
 */
export default function TopNav() {
  const startRequestForm = useAppStore((state) => state.startRequestForm);

  return (
    <>
      <Button variant="text" sx={buttonStyle} component={Link} to="/products">
        Produkte
      </Button>
      {/* <Button variant="text" sx={buttonStyle}>
        Doku
      </Button> */}
      <Button
        variant="outlined"
        sx={{
          ...buttonStyle,
          color: 'main.primary',
          borderWidth: '3px',
          width: '120px',
          height: '40px',
        }}
        component={Link}
        to="/"
        onClick={() => startRequestForm()}
      >
        ANFRAGEN
      </Button>

      <Button
        variant="contained"
        component={Link}
        to="/organizer"
        sx={{
          ...buttonStyle,
          color: 'white',
          width: '120px',
          boxShadow: 'none !important',
          height: '40px',
          '&:hover': {
            backgroundColor: '#19BB5D',
          },
        }}
      >
        Login
      </Button>
    </>
  );
}
